import { IDENTITY_PRODUCT, IDENTITY_URL } from '../../config/retailIdentity';
import { createIdentityClient } from './identityClient';
import { createSessionManager } from './sessionManager';

/** This app's one identity client and session. Constructing them does nothing until used. */
export const retailIdentity = createIdentityClient(IDENTITY_URL, IDENTITY_PRODUCT);
export const retailSession = createSessionManager(retailIdentity);

/** The identity session ended (signed out, expired or revoked); an engine call cannot be made. */
export class IdentitySignedOutError extends Error {
  constructor() {
    super('Your DWLF Retail session has ended. Sign in again.');
    this.name = 'IdentitySignedOutError';
  }
}
